var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Organic Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Organic Line",
      "file": "organic"
    }
  }, [_vm._v(" Organic cotton, Better cotton, Bamboo, Recycled poly, Sorona , Eco Vero, etc. All we must care about the Environment. Accordingly, we are working with factories with certification. Join Meitex to protect the environment! ")])], 1), _c('sub-section', {
    staticClass: "page-section--last"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "py-30 py-md-60 px-30",
    staticStyle: {
      "border": "1px solid #e6e6e6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    staticStyle: {
      "max-width": "600px"
    },
    attrs: {
      "src": "/images/sub/product/organic/main_img.png"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }